import React, { type ReactNode, type MouseEvent } from 'react';
import Button from '@atlaskit/button';
import ShortcutIcon from '@atlaskit/icon/core/migration/link-external--shortcut';
import type { AnalyticsEvent } from '@atlassian/jira-common-analytics-v2-wrapped-components/src/types.tsx';

export type ButtonLinkWithShortcutIconProps = {
	children: ReactNode;
	href?: string;
	innerRef?:
		| {
				current: null | HTMLElement;
		  }
		| ((arg1: null | HTMLElement) => unknown);
	target?: string;
	testId?: string;
	onClick?: (event: MouseEvent, analyticsEvent: AnalyticsEvent) => void;
};

export const ButtonLinkWithShortcutIcon = ({
	href,
	innerRef,
	testId,
	target,
	...props
}: ButtonLinkWithShortcutIconProps) => (
	<Button
		{...props}
		appearance="link"
		href={href}
		// @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
		iconAfter={
			target === '_blank' ? (
				<ShortcutIcon
					color="currentColor"
					LEGACY_size="small"
					label=""
					testId="issue-view-common-views.child-issues-panel.button-link-with-shortcut-icon"
				/>
			) : null
		}
		target={target}
		testId={testId}
		interactionName="auto-generated.jira-issue-view-common-views.child-issues-panel.view.button-link-with-shortcut-icon.button"
	/>
);
